export const INVENTORY_LINE_REMOVE_HIT_WIDTH_PX = 20
export const INVENTORY_LINE_REMOVE_HIT_OPACITY = 0.001

/**
 * Возвращает ширину невидимой области клика линии в режиме удаления.
 * Сохраняет широкую пользовательскую обводку и расширяет только тонкую.
 */
export const resolveInventoryLineRemoveHitWidth = (visualWidth: unknown): number => {
  const normalizedWidth = Number(visualWidth)

  return Number.isFinite(normalizedWidth)
    ? Math.max(normalizedWidth, INVENTORY_LINE_REMOVE_HIT_WIDTH_PX)
    : INVENTORY_LINE_REMOVE_HIT_WIDTH_PX
}
